import { Link } from 'react-router-dom';
import { hotRank } from '@/mocks/feed';

export default function LiveTicker() {
  const loop = [...hotRank, ...hotRank];

  return (
    <section className="relative w-full border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto flex w-full max-w-[1440px] items-stretch px-0 md:px-8">
        <div className="relative z-10 hidden shrink-0 items-center gap-2 bg-primary-500 px-4 md:flex md:px-5">
          <span className="h-1.5 w-1.5 rounded-full bg-white animate-pulse-dot" />
          <span className="font-label text-xs tracking-widest text-white whitespace-nowrap">正在发酵</span>
        </div>
        <div className="relative flex-1 overflow-hidden py-3">
          <div className="flex w-max animate-marquee items-center gap-8">
            {loop.map((item, index) => (
              <Link
                key={`${item.slug}-${index}`}
                to={`/article/${item.slug}`}
                className="flex items-center gap-2 whitespace-nowrap text-xs text-foreground-700 transition-colors hover:text-foreground-950 md:text-sm"
              >
                <span className="flex h-4 w-4 items-center justify-center rounded bg-accent-500/20 font-label text-[10px] text-accent-300">
                  {index % 6 + 1}
                </span>
                <span>{item.title}</span>
                <span className="font-label tabular-nums text-foreground-500">{item.heat.toLocaleString()}</span>
              </Link>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-background-100 to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-background-100 to-transparent" />
        </div>
      </div>
    </section>
  );
}